<template>
  <div class="news">
    <div class="container">
      <Header :headerText="news.header"></Header>
      <div class="row">
        <div class="col-lg-8" style="margin-bottom: 30px;">
          <CarouselNews :data="newsList" @goNewsById="goNewsById"></CarouselNews>
        </div>
        <div class="col-lg-4">
          <LastestNews :data="newsList" :moreNews="news.moreNews" @goNewsById="goNewsById"></LastestNews>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '../COMMON/Header'
import CarouselNews from './CarouselNews'
import LastestNews from './ScrollingNews'
import news from '../../json/news/news.js'

export default {
  components: {
    Header,
    CarouselNews,
    LastestNews
  },
  data () {
    return {
      newsList: []
    }
  },
  props: ['news'],
  created () {
    this.newsList = news.getLastestNews()
  },
  methods: {
    goNewsById: function (newsId) {
      this.$router.push({ name: 'newsById', params: { lang: this.$route.params.lang, newsId: newsId } })
    }
  }
}
</script>

<style scoped>
  .news {
    padding: 90px 0;
    margin-top: 100vh;
    background: #FFF;
  }
</style>



// WEBPACK FOOTER //
// src/components/HOME/LastestNews.vue